module.exports = __webpack_public_path__ + "fonts/cartogothicstd-bold.ttf";